import { useCallback } from 'react';

import { useStoreContext } from 'features/store';

import { useLDContext } from 'state/launchdarkly';

export const useRemoveUnavailableItems = () => {
  const { updateUserStore } = useLDContext();
  const {
    onConfirmStoreChange,
    onConfirmStoreChangeParams,
    clearOnConfirmStoreChangeParams,
    store: activeRestaurant,
  } = useStoreContext();

  const handleConfirmRemoval = useCallback(() => {
    onConfirmStoreChange(onConfirmStoreChangeParams);
    clearOnConfirmStoreChangeParams();
    updateUserStore(activeRestaurant);
  }, [
    clearOnConfirmStoreChangeParams,
    onConfirmStoreChange,
    onConfirmStoreChangeParams,
    activeRestaurant,
    updateUserStore,
  ]);

  return {
    handleConfirmRemoval,
    onConfirmStoreChangeParams,
  };
};
